import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-circle-left-red.svg'
import _imports_1 from '@/app/ui/assets/svg/arrow-circle-right-red.svg'
import _imports_2 from '@/app/ui/assets/svg/chevron-up-light.svg'
import _imports_3 from '@/app/ui/assets/svg/chevron-down-light.svg'
import _imports_4 from '@/app/ui/assets/svg/refresh.svg'
import _imports_5 from '@/app/ui/assets/svg/chevron-down-black.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex fle x-row items-center space-x-4 left-0 ml-8"
}
const _hoisted_2 = { class: "text-12px xxl:text-14px" }
const _hoisted_3 = {
  key: 1,
  class: "flex flex-row space-x-4 left-0 ml-8"
}
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "text-12px xxl:text-14px text-gray-lp-300 font-semibold" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "text-20px flex items-center cursor-pointer ml-2 text-red-lp-100 font-semibold" }
const _hoisted_8 = { style: {"margin-left":"-14px","margin-right":"-14px","width":"300px"} }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "border-b border-gray-lp-400 px-4 py-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "inline-flex justify-between" }, [
    /*#__PURE__*/_createVNode("div", { class: "font-semibold text-16px" }, "Detail berat barang")
  ])
], -1)
const _hoisted_10 = { class: "flex flex-col pb-2 gap-1 p-4 text-14px xxl:text-14px text-black-lp-100" }
const _hoisted_11 = { class: "flex flex-row gap-1" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "flex flex-grow" }, " Total barang ", -1)
const _hoisted_13 = { class: "text-1px text-right" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "flex flex-grow" }, " Total berat kotor ", -1)
const _hoisted_15 = { class: "text-1px text-right" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "flex flex-grow" }, " Total berat dimensi ", -1)
const _hoisted_17 = { class: "text-1px text-right" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "px-4" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_19 = { class: "flex flex-row pb-2" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "flex flex-grow text-black-lp-100 text-14px xxl:text-14px float-left pl-4 pt-2" }, " Berat dikenakan biaya ", -1)
const _hoisted_21 = { class: "text-black-lp-100 text-1px xxl:text-14px pr-4 float-right text-right pt-2" }
const _hoisted_22 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px text-gray-lp-300" }, "Total Tarif", -1)
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = { class: "flex items-center relative" }
const _hoisted_26 = { class: "flex flex-col md:flex-row" }
const _hoisted_27 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px text-gray-lp-300" }, "Total Tarif", -1)
const _hoisted_29 = { class: "flex" }
const _hoisted_30 = { class: "flex items-center relative" }
const _hoisted_31 = {
  key: 0,
  class: "absolute border-l z-10 border-r flex flex-col bg-gray-lp-700 rounded-bl rounded-br shadow w-full -mr-8",
  style: {"margin-bottom":"450px","box-shadow":"0px -5px 5px -1px #e0e0e0"}
}
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "border-b border-gray-lp-700 py-4" }, [
  /*#__PURE__*/_createVNode("div", { class: "flex flex-row justify-between ml-4 mr-8" }, [
    /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px pr-48 pl-4" }, "Detail Pembayaran"),
    /*#__PURE__*/_createVNode("img", {
      src: _imports_5,
      alt: ""
    })
  ])
], -1)
const _hoisted_33 = { class: "flex flex-row justify-between mx-8 border-t border-b border-black-lp-300" }
const _hoisted_34 = { class: "border-b border-gray-lp-700 py-4" }
const _hoisted_35 = { class: "flex flex-col" }
const _hoisted_36 = { class: "text-gray-lp-600 text-12px xxl:text-14px float-left pl-4 flex-col flex" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "pt-4 font-semibold" }, "City Rate", -1)
const _hoisted_38 = { class: "pt-2" }
const _hoisted_39 = { class: "text-gray-lp-600 text-12px xxl:text-14px float-left pl-4 flex-col flex" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "pt-8 font-semibold" }, "Forward Rate", -1)
const _hoisted_41 = { class: "pt-2" }
const _hoisted_42 = { class: "text-gray-lp-600 text-12px xxl:text-14px float-left pl-4 flex-col flex" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "pt-8 font-semibold text-black-lp-300" }, " Biaya Pengiriman ", -1)
const _hoisted_44 = { class: "flex flex-row space-x-2" }
const _hoisted_45 = { class: "pt-2 text-black-lp-300" }
const _hoisted_46 = { class: "text-gray-lp-600 text-12px xxl:text-14px float-left pl-4 flex flex-col" }
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "pt-8 font-semibold" }, "Biaya Tambahan Komoditas", -1)
const _hoisted_48 = { class: "pt-2" }
const _hoisted_49 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_50 = { class: "flex flex-col" }
const _hoisted_51 = { class: "text-gray-lp-600 text-12px xxl:text-14px float-left pl-4 flex flex-col" }
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "pt-4 font-semibold" }, "Biaya Tambahan Berat", -1)
const _hoisted_53 = { class: "pt-2" }
const _hoisted_54 = { class: "text-gray-lp-600 text-12px xxl:text-14px float-left pl-4 flex flex-col" }
const _hoisted_55 = /*#__PURE__*/_createVNode("div", { class: "pt-8 font-semibold" }, "Biaya Tambahan Dokumen", -1)
const _hoisted_56 = { class: "pt-2" }
const _hoisted_57 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_58 = { class: "flex flex-col" }
const _hoisted_59 = { class: "text-black-lp-300 text-12px xxl:text-14px float-left pl-4 flex flex-col" }
const _hoisted_60 = { class: "pt-4 font-semibold" }
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Asuransi + Biaya Admin ")
const _hoisted_62 = {
  key: 0,
  class: "text-black-lp-200 ml-1"
}
const _hoisted_63 = { class: "rounded px-2 py-0 bg-gray-lp-400 text-12px xxl:text-14px" }
const _hoisted_64 = { class: "capitalize" }
const _hoisted_65 = { class: "pt-2" }
const _hoisted_66 = { class: "text-black-lp-300 text-12px xxl:text-14px float-left pl-4 flex flex-col" }
const _hoisted_67 = /*#__PURE__*/_createVNode("div", { class: "pt-8 text-gray-lp-600" }, "COD Amount", -1)
const _hoisted_68 = { class: "pt-2 text-gray-lp-600" }
const _hoisted_69 = { class: "text-black-lp-300 text-12px xxl:text-14px float-left pl-4 flex flex-col" }
const _hoisted_70 = /*#__PURE__*/_createVNode("div", { class: "pt-8 font-semibold" }, "Biaya COD", -1)
const _hoisted_71 = { class: "pt-2" }
const _hoisted_72 = {
  key: 0,
  class: "text-black-lp-300 text-12px xxl:text-14px float-left pl-4 flex flex-col"
}
const _hoisted_73 = /*#__PURE__*/_createVNode("div", { class: "pt-8 text-gray-lp-600" }, "Biaya Retur", -1)
const _hoisted_74 = { class: "pt-2 text-gray-lp-600" }
const _hoisted_75 = { class: "border-b border-gray-lp-400 py-4 pr-6" }
const _hoisted_76 = { class: "flex flex-col" }
const _hoisted_77 = {
  key: 0,
  class: "text-black-lp-300 text-12px xxl:text-14px float-left pl-4 flex flex-col"
}
const _hoisted_78 = { class: "ml-2" }
const _hoisted_79 = { class: "text-12px" }
const _hoisted_80 = { class: "pt-2" }
const _hoisted_81 = { class: "text-gray-lp-600 text-12px xxl:text-14px float-left pl-4 flex flex-col" }
const _hoisted_82 = { class: "pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_discount = _resolveComponent("discount")!
  const _component_select_receipt_language = _resolveComponent("select-receipt-language")!
  const _component_Book = _resolveComponent("Book")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_ModalErrorBalance = _resolveComponent("ModalErrorBalance")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: `flex flex-col md:flex-row items-center ${ _ctx.isShowArrow || _ctx.isShowWeightCost  ? 'justify-between' : 'justify-end' } w-full `
    }, [
      (_ctx.isShowArrow)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("img", {
              alt: "",
              src: _imports_0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.previous()))
            }),
            _createVNode("div", _hoisted_2, _toDisplayString(_ctx.indexElement + 1) + "/" + _toDisplayString(_ctx.shipmentList.length), 1),
            _createVNode("img", {
              alt: "",
              src: _imports_1,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.next()))
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShowWeightCost)
        ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('bookingShipment.column.chargeableWeight')), 1),
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, _toDisplayString(_ctx.chargeableWeight) + " Kg ", 1),
                _withDirectives(_createVNode("div", {
                  class: "flex items-center ml-2",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleTooltip($event)))
                }, [
                  _createVNode("img", {
                    alt: "up",
                    class: `cursor-pointer ${_ctx.isShow ? '' : 'hidden'}`,
                    src: _imports_2
                  }, null, 2),
                  _createVNode("img", {
                    alt: "down",
                    class: `cursor-pointer ${_ctx.isShow ? 'hidden' : ''}`,
                    src: _imports_3
                  }, null, 2)
                ], 512), [
                  [_directive_click_outside, () => _ctx.onCloseAnywhere(false)]
                ])
              ]),
              _createVNode(_component_OverlayPanel, {
                ref: "opTooltip",
                appendTo: "body",
                class: "w-auto",
                unstyled: true
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode("div", _hoisted_10, [
                      _createVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createVNode("div", _hoisted_13, _toDisplayString(_ctx.totalItem), 1)
                      ]),
                      _createVNode("div", {
                        class: `flex flex-row gap-1 ${_ctx.isGrossWeight && !_ctx.isCampaign ? 'text-black-lp-100' : 'text-gray-lp-600'}`
                      }, [
                        _hoisted_14,
                        _createVNode("div", _hoisted_15, _toDisplayString(_ctx.totalGrossWeight) + " kg ", 1)
                      ], 2),
                      _createVNode("div", {
                        class: `flex flex-row gap-1 text-gray-lp-600 ${
                    _ctx.isVolumeWeight && !_ctx.isCampaign
                          ? 'text-black-lp-100'
                          : 'text-gray-lp-600'
                      }`
                      }, [
                        _hoisted_16,
                        _createVNode("div", _hoisted_17, _toDisplayString(_ctx.totalDimensionWeight) + " kg ", 1)
                      ], 2)
                    ]),
                    _hoisted_18,
                    _createVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createVNode("div", _hoisted_21, _toDisplayString(_ctx.chargeableWeight) + " kg ", 1)
                    ])
                  ])
                ]),
                _: 1
              }, 512)
            ]),
            (_ctx.isShowWeightCost)
              ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode("div", _hoisted_24, [
                    _createVNode("div", _hoisted_25, [
                      _withDirectives(_createVNode(_component_Tooltip, {
                        title: "",
                        message: "Perbarui Harga",
                        footer: "",
                        isArrowBottom: false,
                        isArrowRight: "",
                        style: {"width":"150px","margin-top":"-1em","margin-left":"-14em"}
                      }, null, 512), [
                        [_vShow, _ctx.isOpenTooltip]
                      ]),
                      _createVNode("img", {
                        alt: "",
                        class: "cursor-pointer",
                        src: _imports_4,
                        onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onOpenTooltip(true))),
                        onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onOpenTooltip(false))),
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.updateEstimationPrice && _ctx.updateEstimationPrice(...args)))
                      }, null, 32)
                    ]),
                    _createVNode("div", {
                      class: 
              `text-20px ${
                (_ctx.discountData.status || _ctx.dataDetail.isPromo) && !_ctx.isCODOnly
                  ? 'text-gray-lp-600 line-through'
                  : 'text-red-lp-100 font-bold'
              } flex flex-row items-center cursor-pointer ml-1`
            ,
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args)))
                    }, _toDisplayString(_ctx.currency(_ctx.getLabelTotalTarif)), 3),
                    _createVNode("div", {
                      class: "flex items-center ml-3",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args)))
                    }, [
                      _createVNode("img", {
                        alt: "",
                        class: `cursor-pointer ${_ctx.isShow ? '' : 'hidden'}`,
                        src: _imports_2
                      }, null, 2),
                      _createVNode("img", {
                        alt: "",
                        class: `cursor-pointer ${_ctx.isShow ? 'hidden' : ''}`,
                        src: _imports_3
                      }, null, 2)
                    ])
                  ]),
                  _createVNode("div", {
                    class: "flex cursor-pointer",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args)))
                  }, [
                    (_ctx.discountData.status || _ctx.dataDetail.isPromo)
                      ? (_openBlock(), _createBlock(_component_discount, {
                          key: 0,
                          showDiscountNominal: _ctx.isCODOnly ? false : _ctx.showDiscountNominal,
                          discountData: _ctx.discountData.data,
                          tariffAfterDiscount: this.payload.isCOD || this.payload.isDFOD ? _ctx.dataDetail.codAmount : _ctx.dataDetail.totalTariffAfterDiscount,
                          defaultDiscount: _ctx.dataDetail.listDiscount
                        }, null, 8, ["showDiscountNominal", "discountData", "tariffAfterDiscount", "defaultDiscount"]))
                      : _createCommentVNode("", true)
                  ])
                ], 512)), [
                  [_directive_click_outside, () => _ctx.onCloseAnywhere(false)]
                ])
              : _createCommentVNode("", true)
          ], 512)), [
            [_directive_click_outside, () => _ctx.onCloseAnywhere(false)]
          ])
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_26, [
        (!_ctx.isShowWeightCost)
          ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_27, [
              _hoisted_28,
              _createVNode("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, [
                  _withDirectives(_createVNode(_component_Tooltip, {
                    title: "",
                    message: "Perbarui Harga",
                    footer: "",
                    isArrowBottom: false,
                    isArrowRight: "",
                    style: {"width":"150px","margin-top":"-1em","margin-left":"-14em"}
                  }, null, 512), [
                    [_vShow, _ctx.isOpenTooltip]
                  ]),
                  _createVNode("img", {
                    alt: "",
                    class: "cursor-pointer",
                    src: _imports_4,
                    onMouseenter: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onOpenTooltip(true))),
                    onMouseleave: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onOpenTooltip(false))),
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.updateEstimationPrice && _ctx.updateEstimationPrice(...args)))
                  }, null, 32)
                ]),
                _createVNode("div", {
                  class: 
              `text-20px ${
                (_ctx.discountData.status || _ctx.dataDetail.isPromo) && !_ctx.isCODOnly
                  ? 'text-gray-lp-600 line-through'
                  : 'text-red-lp-100 font-bold'
              } flex flex-row items-center cursor-pointer ml-1`
            ,
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args)))
                }, _toDisplayString(_ctx.currency(_ctx.getLabelTotalTarif)), 3),
                _createVNode("div", {
                  class: "flex items-center ml-3",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args)))
                }, [
                  _createVNode("img", {
                    alt: "",
                    class: `cursor-pointer ${_ctx.isShow ? '' : 'hidden'}`,
                    src: _imports_2
                  }, null, 2),
                  _createVNode("img", {
                    alt: "",
                    class: `cursor-pointer ${_ctx.isShow ? 'hidden' : ''}`,
                    src: _imports_3
                  }, null, 2)
                ])
              ]),
              _createVNode("div", {
                class: "flex cursor-pointer",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args)))
              }, [
                (_ctx.discountData.status || _ctx.dataDetail.isPromo)
                  ? (_openBlock(), _createBlock(_component_discount, {
                      key: 0,
                      showDiscountNominal: _ctx.isCODOnly ? false : _ctx.showDiscountNominal,
                      discountData: _ctx.discountData.data,
                      tariffAfterDiscount: this.payload.isCOD || this.payload.isDFOD ? _ctx.dataDetail.codAmount : _ctx.dataDetail.totalTariffAfterDiscount,
                      defaultDiscount: _ctx.dataDetail.listDiscount
                    }, null, 8, ["showDiscountNominal", "discountData", "tariffAfterDiscount", "defaultDiscount"]))
                  : _createCommentVNode("", true)
              ])
            ], 512)), [
              [_directive_click_outside, () => _ctx.onCloseAnywhere(false)]
            ])
          : _createCommentVNode("", true),
        (_ctx.isInterpack)
          ? (_openBlock(), _createBlock(_component_select_receipt_language, {
              key: 1,
              customStyleList: "bottom: 4.5rem",
              class: "pl-6 pr-4"
            }))
          : _createCommentVNode("", true),
        (_ctx.isBooking)
          ? (_openBlock(), _createBlock(_component_Book, {
              key: 2,
              class: "mt-2",
              bookingType: _ctx.bookingType,
              payload: _ctx.payload,
              isPrintAble: _ctx.isPrintAble,
              isDisabled: _ctx.isDisabled,
              algoId: _ctx.algoId,
              comodityCode: _ctx.comodityCode,
              onBooking: _ctx.updateEstimationPrice
            }, null, 8, ["bookingType", "payload", "isPrintAble", "isDisabled", "algoId", "comodityCode", "onBooking"]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (_ctx.isShow)
      ? (_openBlock(), _createBlock("div", _hoisted_31, [
          _hoisted_32,
          _createVNode("div", _hoisted_33, [
            _createVNode("div", _hoisted_34, [
              _createVNode("div", _hoisted_35, [
                _createVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createVNode("div", _hoisted_38, _toDisplayString(_ctx.currency(_ctx.dataDetail.cityRates)), 1)
                ]),
                _createVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createVNode("div", _hoisted_41, _toDisplayString(_ctx.currency(_ctx.dataDetail.forwardRates)), 1)
                ]),
                _createVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createVNode("div", _hoisted_44, [
                    _createVNode("div", _hoisted_45, _toDisplayString(_ctx.currency(_ctx.dataDetail.shippingCost)), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _createVNode("div", _hoisted_48, _toDisplayString(_ctx.currency(_ctx.dataDetail.commoditySurcharge)), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_49, [
              _createVNode("div", _hoisted_50, [
                _createVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createVNode("div", _hoisted_53, _toDisplayString(_ctx.currency(_ctx.dataDetail.heavyWeightSurcharge)), 1)
                ]),
                _createVNode("div", _hoisted_54, [
                  _hoisted_55,
                  _createVNode("div", _hoisted_56, _toDisplayString(_ctx.currency(_ctx.dataDetail.documentSurcharge)), 1)
                ]),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('Biaya Packing Kayu'),
                  class: "pt-8 pl-4",
                  customClass: "text-gray-lp-600",
                  value: _ctx.currency(_ctx.dataDetail.woodpackingRates)
                }, null, 8, ["label", "value"]),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('Biaya Tambahan'),
                  class: "pt-8 pl-4",
                  value: _ctx.additionalRate
                }, null, 8, ["label", "value"])
              ])
            ]),
            _createVNode("div", _hoisted_57, [
              _createVNode("div", _hoisted_58, [
                _createVNode("div", _hoisted_59, [
                  _createVNode("div", _hoisted_60, [
                    _hoisted_61,
                    (_ctx.dataDetail.insuranceName)
                      ? (_openBlock(), _createBlock("span", _hoisted_62, [
                          _createVNode("span", _hoisted_63, [
                            _createVNode("span", _hoisted_64, _toDisplayString(_ctx.dataDetail.insuranceName.replace("Insurance", "")), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_65, _toDisplayString(_ctx.currency(_ctx.dataDetail.insuranceRates)), 1)
                ]),
                _createVNode("div", _hoisted_66, [
                  _hoisted_67,
                  _createVNode("div", _hoisted_68, _toDisplayString(_ctx.currency(_ctx.dataDetail.codAmount)), 1)
                ]),
                _createVNode("div", _hoisted_69, [
                  _hoisted_70,
                  _createVNode("div", _hoisted_71, _toDisplayString(_ctx.currency(_ctx.dataDetail.codFee)), 1)
                ]),
                (_ctx.prefixShipmentCod || _ctx.isShipmentFavoriteCOD)
                  ? (_openBlock(), _createBlock("div", _hoisted_72, [
                      _hoisted_73,
                      _createVNode("div", _hoisted_74, _toDisplayString(_ctx.currency(_ctx.codReturnValue)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_75, [
              _createVNode("div", _hoisted_76, [
                (_ctx.discountData.status || _ctx.dataDetail.isPromo)
                  ? (_openBlock(), _createBlock("div", _hoisted_77, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataDetail.discountBoards, (promo, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index,
                          class: "flex flex-col"
                        }, [
                          _createVNode("div", {
                            class: 
                  `${index ? 'pt-8 mt-1' : 'pt-3'} flex flex-row items-center`
                
                          }, [
                            _createVNode("div", null, _toDisplayString(`${_ctx.startCase(promo.pdcCategory)} Promo`), 1),
                            _createVNode("div", _hoisted_78, [
                              _createVNode("div", {
                                class: "flex flex-row bg-green-lp-700 text-white text-10px px-1 rounded-md cursor-pointer\n                    ",
                                onMouseenter: ($event: any) => (_ctx.onOpenTooltipPromo($event, index)),
                                onMouseleave: ($event: any) => (_ctx.onOpenTooltipPromo($event, index))
                              }, [
                                _createVNode("p", null, _toDisplayString(promo.pdcPromoDiscount) + "% Off", 1),
                                _createVNode(_component_Icons, {
                                  name: "info",
                                  class: "w-3 ml-1"
                                })
                              ], 40, ["onMouseenter", "onMouseleave"]),
                              _createVNode(_component_OverlayPanel, {
                                ref: `infoPromo${index}`,
                                appendTo: "body",
                                class: "text-center",
                                style: {"width":"200px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode("p", _hoisted_79, _toDisplayString(promo.pdcName) + " sampai dengan " + _toDisplayString(_ctx.formatDateWithoutTime(promo.pdcEndDate)), 1)
                                ]),
                                _: 2
                              }, 1536)
                            ])
                          ], 2),
                          _createVNode("div", _hoisted_80, _toDisplayString(_ctx.currency(promo.pdcDiscountAmount)), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_81, [
                  _createVNode("div", {
                    class: 
                `${
                  _ctx.discountData.status || _ctx.dataDetail.isPromo ? 'pt-8' : 'pt-4'
                } font-semibold`
              
                  }, " Est. Pajak ", 2),
                  _createVNode("div", _hoisted_82, _toDisplayString(_ctx.currency(_ctx.dataDetail.taxRates)), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalErrorBalance, {
      modelValue: _ctx.balanceUnderLimit,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.balanceUnderLimit = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}